import { requestWithToken } from '../../utilities/request';

/**
 * 職種一覧取得API
 * */
const fetchJobCategoriesList = () => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/ccus/masters/ginou_syokusyus',
  });
};

export const JobCategoryApi = {
  fetchJobCategoriesList,
};

export default JobCategoryApi;



// WEBPACK FOOTER //
// ./src/services/jobCategory/JobCategoryApi.js